import React from 'react'
import { connect } from 'react-redux'
import Wrapper from './WidgetCardWrapper'
import { translate } from 'react-i18next'
import { DATASOURCE } from 'Constants'
import BaseWidget from './BaseWidget'
import BarChart from 'components/BarChart'

class CallDuration extends BaseWidget {
  constructor(props) {
    super(props,DATASOURCE.SUMMARY);
  }

  static defaultGridItemProps(){
    return {
      w: 4,
      h: 12,
      maxW: 6,
      maxH: 16
    };
  }

  render() {
    const { t } = this.props;
    return (
      <Wrapper {...this.props}
        isLoading={this.props.summary.loading}
      >
        <BarChart
          decimals={0}
          type="bar"
          yAxisText={t("Widgets.CallDurationYAxis")}
          series={this.props.summary.durationSeries}
          xAxisCategories={this.props.summary.durationCategories}
          stackBars="normal"
        />
      </Wrapper>
    );
  }
}

// Helper functions
const mapToProps = state => {
  return {
    summary: state.summary,
    history: state.router
  }
};
        
export default translate()(
  connect(
    mapToProps,
    null
  )(CallDuration)
);

